// extracted by mini-css-extract-plugin
export var columns = "styles-module--columns--24ai1";
export var column = "styles-module--column--IMaAl";
export var formHeader = "styles-module--formHeader--2-9Qy";
export var formSubHeader = "styles-module--formSubHeader--2G4hE";
export var contactUs = "styles-module--contactUs--3hU8E";
export var contactUsButtonWrapper = "styles-module--contactUsButtonWrapper--2jUdq";
export var contactUsWrapper = "styles-module--contactUsWrapper--3qM55";
export var supportMessage = "styles-module--supportMessage--xm63E";
export var supportEmail = "styles-module--supportEmail--YGZMN";